import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Appearance, DraftConfiguration } from '@/types';
import { isDraftDesignConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getIsDieCutStickerAppearance } from '@/model/productType/getIsDieCutStickerAppearance';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { getSelectedConfiguration } from '@/redux/draft/getters/getSelectedConfiguration';
import { CTA } from './CTA';
import { DesignConfigurationPanel } from './design-configuration/DesignConfigurationPanel';
import { ProductTypePanel } from './product-info/ProductTypePanel';
import { ProductTypePanelWithLayers } from './product-info/ProductTypePanelWithLayers';
import { StickerPanel } from './product-info/StickerPanel';
import { TextPanel } from './text-configuration/TextPanel';
import './PanelContainer.scss';

const getPanelContent = (appearance: Appearance, configuration?: DraftConfiguration) => {
  if (getIsDieCutStickerAppearance(appearance)) {
    return <StickerPanel Panel={ProductTypePanel} />;
  }

  if (configuration) {
    if (isDraftDesignConfiguration(configuration)) {
      return <DesignConfigurationPanel configuration={configuration} />;
    }

    return <TextPanel configuration={configuration} />;
  }

  return <ProductTypePanelWithLayers Panel={ProductTypePanel} />;
};

export const PanelContainer: FunctionComponent = () => {
  const configuration = useSelector(getSelectedConfiguration);
  const appearance = useSelector(getCurrentAppearance);

  return (
    <div className="right-column">
      <div className="settings">{getPanelContent(appearance, configuration)}</div>
      <CTA />
    </div>
  );
};
